import * as React from "react";
const SvgFiRrPlugAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-plug-alt_svg__a)">
      <path
        fill="#062147"
        d="M20.003 3.058C17.465.785 14.053-.298 10.638.075 5.126.684.684 5.125.075 10.639c-.67 6.064 3.155 11.765 8.897 13.257q.406.105.813.104c.701 0 1.386-.231 1.958-.674a3.21 3.21 0 0 0 1.256-2.557v-2.87a5.01 5.01 0 0 0 4-4.9v-1a1 1 0 1 0 0-2h-2V7a1 1 0 1 0-2 0v3h-2V7a1 1 0 1 0-2 0v3h-2a1 1 0 1 0 0 2v1a5.01 5.01 0 0 0 4 4.9v2.87c0 .384-.175.738-.479.974a1.2 1.2 0 0 1-1.045.217c-4.709-1.225-7.965-6.101-7.412-11.103.507-4.588 4.206-8.287 8.794-8.794 2.891-.316 5.665.562 7.812 2.484A10.02 10.02 0 0 1 22 11.999a9.94 9.94 0 0 1-6.363 9.318 1 1 0 0 0-.568 1.295 1 1 0 0 0 1.295.568c4.64-1.811 7.637-6.2 7.637-11.182a12.02 12.02 0 0 0-3.997-8.942zM9 13v-1h6v1c0 1.654-1.346 3-3 3s-3-1.346-3-3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-plug-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPlugAlt;
